import axiosInstance from './axiosInstance';

const API_URL = process.env.REACT_APP_API_URL;

export const getCustomReports = async () => {
  const response = await axiosInstance.get(`${API_URL}/custom-reports`);
  return response.data;
};

export const createCustomReport = async (payload) => {
  const response = await axiosInstance.post(`${API_URL}/custom-reports`, payload);
  return response.data;
};

export const updateCustomReport = async (id, payload) => {
  const response = await axiosInstance.put(`${API_URL}/custom-reports/${id}`, payload);
  return response.data;
};

export const deleteCustomReport = async (id) => {
  const response = await axiosInstance.delete(`${API_URL}/custom-reports/${id}`);
  return response.data;
};
